var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMetabotBugReport = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 96,
  height: 96,
  viewBox: "0 0 96 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2220_3759)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_2220_3759",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 96,
  height: 96
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M96 0H0V96H96V0Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_2220_3759)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48 96C74.5097 96 96 74.5097 96 48C96 21.4903 74.5097 0 48 0C21.4903 0 0 21.4903 0 48C0 74.5097 21.4903 96 48 96Z",
  fill: "#74BCFC",
  fillOpacity: 0.21
}), /*#__PURE__*/React.createElement("path", {
  d: "M68 31.0005H28C25.7909 31.0005 24 32.7913 24 35.0005V61.0005C24 63.2096 25.7909 65.0005 28 65.0005H68C70.2091 65.0005 72 63.2096 72 61.0005V35.0005C72 32.7913 70.2091 31.0005 68 31.0005Z",
  fill: "#DEEDFA",
  stroke: "#509EE3",
  strokeWidth: 1.25,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65 36.5005H31C30.1716 36.5005 29.5 37.1721 29.5 38.0005V55.0005C29.5 55.8289 30.1716 56.5005 31 56.5005H65C65.8284 56.5005 66.5 55.8289 66.5 55.0005V38.0005C66.5 37.1721 65.8284 36.5005 65 36.5005Z",
  fill: "white",
  stroke: "#509EE3",
  strokeWidth: 1.25,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.161 60.7148C62.161 61.3164 61.6733 61.8041 61.0717 61.8041C60.4701 61.8041 59.9824 61.3164 59.9824 60.7148C59.9824 60.1132 60.4701 59.6255 61.0717 59.6255C61.6733 59.6255 62.161 60.1132 62.161 60.7148Z",
  stroke: "#509EE3",
  strokeWidth: 1.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.661 60.7148C66.661 61.3164 66.1733 61.8041 65.5717 61.8041C64.9701 61.8041 64.4824 61.3164 64.4824 60.7148C64.4824 60.1132 64.9701 59.6255 65.5717 59.6255C66.1733 59.6255 66.661 60.1132 66.661 60.7148Z",
  stroke: "#509EE3",
  strokeWidth: 1.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M41 45C41.8284 45 42.5 44.3284 42.5 43.5C42.5 42.6716 41.8284 42 41 42C40.1716 42 39.5 42.6716 39.5 43.5C39.5 44.3284 40.1716 45 41 45Z",
  fill: "#509EE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55 45C55.8284 45 56.5 44.3284 56.5 43.5C56.5 42.6716 55.8284 42 55 42C54.1716 42 53.5 42.6716 53.5 43.5C53.5 44.3284 54.1716 45 55 45Z",
  fill: "#509EE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.25 47.5C50.25 48.9912 49.2426 49.75 48 49.75C46.7574 49.75 45.75 48.9912 45.75 47.5",
  stroke: "#509EE3",
  strokeWidth: 1.25
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.25,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.161 54.0104C18.5753 54.5962 18.5753 55.5459 19.161 56.1317L26.7975 63.7682C27.2376 64.2083 27.9038 64.3309 28.4718 64.0763L33.5266 61.8104L41.6362 69.92C42.0268 70.3105 42.6599 70.3105 43.0505 69.92C43.441 69.5295 43.441 68.8963 43.0505 68.5058L34.864 60.3193L37.0051 55.543C37.2597 54.975 37.1371 54.3088 36.697 53.8687L29.0605 46.2322C28.4748 45.6465 27.525 45.6465 26.9392 46.2322L19.161 54.0104Z",
  fill: "#509EE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5657 57.0204C34.1751 56.6299 33.542 56.6299 33.1514 57.0204C32.7609 57.411 32.7609 58.0441 33.1514 58.4346L41.6367 66.9199C42.0272 67.3105 42.6604 67.3105 43.0509 66.9199C43.4415 66.5294 43.4415 65.8962 43.0509 65.5057L34.5657 57.0204Z",
  fill: "white",
  stroke: "#509EE3",
  strokeWidth: 1.25,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.161 53.1317C18.5753 52.5459 18.5753 51.5962 19.161 51.0104L26.9392 43.2322C27.525 42.6465 28.4748 42.6465 29.0605 43.2322L36.697 50.8687C37.1371 51.3088 37.2597 51.975 37.0051 52.543L34.5976 57.9136C34.447 58.2495 34.1783 58.5182 33.8424 58.6688L28.4718 61.0763C27.9038 61.3309 27.2376 61.2083 26.7975 60.7682L19.161 53.1317Z",
  fill: "white",
  stroke: "#509EE3",
  strokeWidth: 1.25,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5449 53.4849L29.616 46.4138",
  stroke: "#509EE3",
  strokeWidth: 1.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.7871 57.7275L33.8582 50.6565",
  stroke: "#509EE3",
  strokeWidth: 1.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.5654 55.5059L31.6365 48.4348",
  stroke: "#509EE3",
  strokeWidth: 1.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.616 57.7275L22.5449 50.6565",
  stroke: "#509EE3",
  strokeWidth: 1.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.8582 53.4849L26.7871 46.4138",
  stroke: "#509EE3",
  strokeWidth: 1.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.7371 55.6063L24.666 48.5352",
  stroke: "#509EE3",
  strokeWidth: 1.25
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2220_3759"
}, /*#__PURE__*/React.createElement("rect", {
  width: 96,
  height: 96,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMetabotBugReport);
export default ForwardRef;